import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { AES, enc } from "crypto-js";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import {
  AVAILABILITY_CONSTANTS,
  AVAILIABILITY_ACCESS,
  EVENTS_STATES
} from "@/modules/Availability/constants/AvailabilityConstants";
import { AvailabilityModel } from "@/modules/Availability/models/AvailabilityModel";
import {
  COMPLETE_SERVICE,
  DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE,
  PROFILE_CONSTANTS,
  SAME_TIME_RANGE_SERVICE_MESSAGE
} from "@/modules/Profile/constants/ProfileConstants";
import {
  GENERAL_CONSTANTS,
  OPTIONS_LOCALE_DATE,
  PANEL_INFO_CONSTANTS,
  SOCKET_TOPICS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { MedicalAppointmentService } from "@/modules/MedicalAppointment/services/MedicalAppointmentService";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { AvailabilityService } from "../../../Availability/services/AvailabilityService";
import { MedicalAppointment } from "../../../MedicalAppointment/models/MedicalAppointment";
import { UserStatus } from "../../../User/models/UserStatus";
import { UserService } from "../../../User/services/UserService";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import TimeOutModal from "./components/TimeOutModal/TimeOutModal.vue";
import { EventDataModel } from "./models/EventDataModel";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { VerifiedAppointmentsResponse } from "./models/verified-response.model";

import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { DEFAULT_SCROLL_TO_TIME } from "../../../Availability/constants/AvailabilityConstants";
import AssignServiceTemplate from "@/modules/Profile/components/AssignServiceTemplate/AssignServiceTemplate.vue";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import { Service } from "@/modules/Services/models/Service";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import {
  SERVICES_ACCESS,
  SERVICES_CONTANTS
} from "@/modules/Services/constants/ServicesConstants";
import { CAMPUS_ACCESS } from "@/modules/Campus/constants/CampusConstants";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { MEDICAL_APPOINTMENT_ACCESS } from "@/modules/MedicalAppointment/constants/MedicalAppointmentConstants";
import moment from "moment";
import * as APPOINTMENT_CONSTANTS from "./constants/AppointmentsConstants";
import { AvailabilityEvent } from "@/modules/Availability/models/AvailabilityEventModel";

Vue.use(Vuetify);
@Component({
  name: "Appointment",
  components: {
    ObservationModal,
    TimeOutModal,
    ModalTemplate,
    AssignServiceTemplate
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Appointment extends Vue {
  @Inject() medicalAppointmentService!: MedicalAppointmentService;
  @Inject() campusService!: CampusService;
  @Inject() availabilityService!: AvailabilityService;
  @Inject() userService!: UserService;
  @Inject() servicesService!: ServicesService;

  @Prop({ default: false }) private dialogProp?: boolean;
  @Prop() private medicalAppointmentProp?: string;
  @Prop() private appointmentServiceNameProp?: string;
  @Prop() serviceTemplateIdProp?: string;
  @Prop() serviceIdProp?: string;
  @Prop() private patientIdProp?: string;
  @Prop() data?: ServiceHeaderData[];
  @Prop() currentService?: ServiceHeaderData;

  dataToMainView!: MenuDataStructure;

  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  CONFIRM_APPOINTMENT_BTN = PROFILE_CONSTANTS.LABELS.CONFIRM_APPOINTMENT;
  CANCEL_APPOINTMENT_BTN = PROFILE_CONSTANTS.LABELS.CANCEL_APPOINTMENT;
  LOCALE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.LOCALE;
  LOAD_MORE_OPTIONS = GENERAL_CONSTANTS.TEXTS.LOAD_MORE_OPTIONS;
  VIEW_TYPE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.VIEW_TYPES[1].value;
  VIEW_TYPES = AVAILABILITY_CONSTANTS.CONFIGURATIONS.VIEW_TYPES;
  OVERLAP_MODE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.OVERLAP_MODE;
  TODAY = AVAILABILITY_CONSTANTS.TEXTS.TODAY;
  SERVICE_LBL = PROFILE_CONSTANTS.LABELS.SERVICE;
  DATE_LBL = PROFILE_CONSTANTS.LABELS.DATE;
  PLACE_LBL = PROFILE_CONSTANTS.LABELS.PLACE;
  CAMPUS_LBL = PROFILE_CONSTANTS.LABELS.CAMPUS;
  OBSERVATION_LBL = PROFILE_CONSTANTS.LABELS.OBSERVATION;
  SCHEDULE_LBL = PROFILE_CONSTANTS.LABELS.SCHEDULE;
  APPOINTMENT_LBL = PROFILE_CONSTANTS.LABELS.APPOINTMENT;
  PATIENT_LBL = PROFILE_CONSTANTS.LABELS.PATIENT;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  vSheetClass = STYLE_CLASSES.V_SHEET;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  primaryColor = STYLE_CLASSES.CHIP_COLOR.FILLED;

  maxWidth = 1500;
  calendarValue = new Date().getTime();
  eventList: AvailabilityModel[] = [];
  eventCalendarList: AvailabilityModel[] = [];
  userInfo: UserStatus = {
    id: "",
    userEmail: "",
    userPhone: "",
    userName: "",
    userState: "",
    name: ""
  };
  showObservationField = false;
  showCancelField = false;
  showMoreOptions = false;
  eventSelected = -1;
  observation = "";
  suggestions = "";
  appointmentPlace = "";
  appointmentCampus = "";
  appointmentDate = "";
  campusList: any[] = [];
  campusKey = "";
  eventKey = "";
  dateRef = 0;
  campusAddress = "";
  campusPhone = "";

  showTimeOutModal = false;

  dialog = false;
  modalText = "";
  modalTitle = "Verificación";

  step = 2;
  serviceToAssing = {} as Service;
  assingService = false;
  canCancelAppointment = true;
  keyStep = 0;
  loading = false;
  dialogConfirmation = false;
  modalTextConfirmation = "";
  modalTitleConfirmation = "";
  enabledConfirmAppontmentButton = false;

  @Watch("serviceIdProp")
  handleServiceIdProp() {
    this.canCancelAppointment = this.checkCompleteState();
  }

  @Watch("serviceTemplateIdProp")
  handleServiceTemplateIdProp() {
    if (this.serviceTemplateIdProp) {
      this.step = 2;
    } else {
      this.step = 1;
    }
  }

  @Watch("step")
  changeStep() {
    this.keyStep++;
  }

  @Watch("patientIdProp")
  handlePatientIdProp() {
    if (this.patientIdProp) {
      this.getUserData(this.patientIdProp);
    }
  }

  async mounted() {
    this.initialCalendarScrollToTime();
    this.canCancelAppointment = this.checkCompleteState();
    if (this.patientIdProp) {
      await this.getUserData(this.patientIdProp);
    }

    await this.restoreModal();
    this.handleServiceTemplateIdProp();
    this.initListener();
  }
  initListener() {
    this.$socket.$subscribe(
      SOCKET_TOPICS.AVAILABILITY_CHANGED,
      this.processAvailabilityPayload
    );
  }

  processAvailabilityPayload(payload: string) {
    const payloadBytes = AES.decrypt(
      payload,
      process.env.VUE_APP_TOKEN_SECRET as string
    );
    const medicalData = payloadBytes.toString(enc.Utf8);
    const data: AvailabilityModel = JSON.parse(medicalData);
    const validate = this.validatesAvailability(data);
    if (validate) {
      this.mapEvents(data);
    }
  }

  validatesAvailability(availability: AvailabilityModel) {
    if (
      this.serviceTemplateIdProp &&
      !(availability.serviceTemplate as string[]).includes(
        this.serviceTemplateIdProp as string
      )
    ) {
      return false;
    }
    if (this.campusKey && availability.campus != this.campusKey) {
      return false;
    }
    if ((availability.end as number) < new Date().getTime()) {
      return false;
    }
    return true;
  }

  syncronizeEventsIndex(eventList: AvailabilityModel[]) {
    this.eventCalendarList = eventList.map((item, index) => ({
      ...item,
      index
    }));
  }

  mapEvents(availability: AvailabilityModel) {
    const availableEvents: AvailabilityEvent[] = [];
    const unAvailableEvents: AvailabilityEvent[] = availability.events.filter(
      (event: AvailabilityEvent) => {
        if (event.status != EVENTS_STATES.AVAILABLE) return true;
        else {
          availableEvents.push(event);
          return false;
        }
      }
    );
    for (const event of availableEvents) {
      this.addNewEvents(event, availability.id);
    }
    for (const event of unAvailableEvents) {
      this.findAndDelete(event, availability.id);
    }
    this.syncronizeEventsIndex(this.eventCalendarList);
  }

  addNewEvents(event: AvailabilityEvent, availabilityId?: string) {
    const exist = this.eventCalendarList.some(
      item => item.start == event.start && item.campus == availabilityId
    );
    if (!exist && event.start > new Date().getTime()) {
      this.eventCalendarList.push({
        name: new Date(event.start as number).toLocaleString(
          "es-CO",
          OPTIONS_LOCALE_DATE
        ),
        start: event.start as number,
        end: event.end as number,
        status: event.status,
        timed: true,
        index: this.eventCalendarList.length,
        _key: event._key,
        campus: availabilityId
      });
    }
  }
  findAndDelete(event: AvailabilityEvent, availabilityId?: string) {
    const index = this.eventCalendarList.findIndex(
      item =>
        item._key == event._key &&
        item.status == EVENTS_STATES.AVAILABLE &&
        item.campus == availabilityId
    );
    if (index != -1) {
      const deleted = this.eventCalendarList.splice(index, 1);
      if (deleted[0]._key != event._key) {
        this.eventCalendarList.push(deleted[0]);
        this.findAndDelete(event, availabilityId);
      }
    }
  }

  initialCalendarScrollToTime() {
    if (this.$refs && this.$refs.calendar) {
      const scroll = this.$refs.calendar as Vue & {
        scrollToTime: (data: string) => void;
      };
      if (scroll.scrollToTime) {
        scroll.scrollToTime(DEFAULT_SCROLL_TO_TIME);
      }
    }
  }

  async getUserData(userId: string) {
    try {
      const responseData = await this.userService.getUserBasicInfo(userId);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfo = responseData.data;
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("campusKey")
  async getEventsCampus(restoreList = true) {
    this.loading = true;
    if (this.eventList.length > 0 && restoreList) {
      await this.unlockEventsFromEventList();
    }
    this.initialCalendarScrollToTime();
    if (this.campusKey !== "") {
      if (restoreList) {
        this.eventList = [];
        this.eventCalendarList = [];
        this.dateRef = new Date().getTime();
        this.showObservationField = false;
        this.eventSelected = -1;
        this.getCampus();
      }
      try {
        const responseData = await this.availabilityService.availableEvents(
          this.serviceTemplateIdProp as string,
          this.campusKey,
          this.dateRef,
          this.patientIdProp as string
        );

        if (responseData.code === Http.Found && responseData.data) {
          responseData.data.sort(function(a, b) {
            if (a.end > b.end) {
              return 1;
            }
            if (a.end < b.end) {
              return -1;
            }
            return 0;
          });
          for (let index = 0; index < responseData.data.length; index++) {
            this.eventList.push({
              name: new Date(
                responseData.data[index].start as number
              ).toLocaleString("es-CO", OPTIONS_LOCALE_DATE),
              start: responseData.data[index].start as number,
              end: responseData.data[index].end as number,
              status: AVAILABILITY_CONSTANTS.TEXTS.LOCKED,
              timed: true,
              index: this.eventList.length,
              _key: responseData.data[index]._key,
              campus: responseData.data[index].availabilityId
            });
            this.dateRef = responseData.data[index].end as number;
          }

          this.eventCalendarList = [...this.eventList];

          this.showMoreOptions = true;
          this.calendarValue = this.eventList[0].start as number;
        } else {
          Snackbar.popWarning(responseData.message);
          this.showMoreOptions = false;
        }
        const moreEvents = await this.findMoreAvailableEvents();
        this.syncronizeEventsIndex([...this.eventList, ...moreEvents]);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${AVAILIABILITY_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
        this.showMoreOptions = false;
      }
    }
  }

  async findMoreAvailableEvents() {
    const eventCalendarList = [];
    try {
      const responseData = await this.availabilityService.moreAvailableEvents(
        this.serviceTemplateIdProp as string,
        this.campusKey,
        new Date().getTime()
      );

      if (responseData.code === Http.Found && responseData.data) {
        for (let index = 0; index < responseData.data.length; index++) {
          const timeToCompare = responseData.data[index].start;
          const foundEvent = this.eventList.find(event => {
            if (event.start === timeToCompare) {
              return event;
            }
          });
          if (foundEvent === undefined) {
            eventCalendarList.push({
              name: new Date(
                responseData.data[index].start as number
              ).toLocaleString("es-CO", OPTIONS_LOCALE_DATE),
              start: responseData.data[index].start as number,
              end: responseData.data[index].end as number,
              status: responseData.data[index].status,
              timed: true,
              _key: responseData.data[index]._key,
              campus: responseData.data[index].availabilityId
            });
          }
        }
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${AVAILIABILITY_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    return eventCalendarList;
  }

  getEventColor(event: AvailabilityModel) {
    if (event.index == this.eventSelected) {
      return this.primaryColor;
    }
    if (event.color) {
      return event.color;
    }
    if (event.status === AVAILABILITY_CONSTANTS.TEXTS.AVAILABLE) {
      return AVAILABILITY_CONSTANTS.COLORS.GREEN;
    } else if (event.status === AVAILABILITY_CONSTANTS.TEXTS.LOCKED) {
      return AVAILABILITY_CONSTANTS.COLORS.GREY;
    } else {
      return AVAILABILITY_CONSTANTS.COLORS.PURPLE;
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  getEventName(eventCalendar: any) {
    return eventCalendar.input.status;
  }

  goToCurrentDate() {
    this.calendarValue = new Date().getTime();
  }

  capitalizeMonths(monthName: string): string {
    if (monthName) {
      const splittedName = monthName.split(
        AVAILABILITY_CONSTANTS.SPLITTERS.MONTH
      );

      for (let i = 0; i < splittedName.length; i++) {
        splittedName[i] =
          splittedName[i].charAt(0).toUpperCase() + splittedName[i].slice(1);
      }

      return splittedName.join(AVAILABILITY_CONSTANTS.SPLITTERS.MONTH);
    } else {
      return "";
    }
  }

  @Watch("dialogProp")
  async restoreModal() {
    if (this.dialogProp) {
      this.maxWidth = 1200;
      this.eventList = [];
      this.eventCalendarList = [];
      this.showObservationField = false;
      this.showCancelField = false;
      this.eventSelected = -1;
      this.observation = "";
      this.campusKey = "";
      this.showMoreOptions = false;
      this.dateRef = new Date().getTime();
      if (this.medicalAppointmentProp) {
        this.maxWidth = 750;
        await this.getAppointmentDetail(this.medicalAppointmentProp);
      } else if (this.serviceTemplateIdProp) {
        try {
          const responseData = await this.availabilityService.getCampusAvailables(
            this.serviceTemplateIdProp
          );

          if (responseData.code === Http.Found && responseData.data) {
            this.campusList = responseData.data;
          } else {
            Snackbar.popWarning(responseData.message);
            this.closeModal();
          }
        } catch (error) {
          const errorMessage =
            (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
              ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CAMPUS_ACCESS.GET}`
              : FORM_MESSAGES.REQUEST_FAILED;

          Snackbar.popError(errorMessage);
        }
      }
    }
  }

  closeModal(refreshList = false) {
    this.showTimeOutModal = false;
    this.unlockEventsFromEventList();
    this.$emit(
      PROFILE_CONSTANTS.EMIT_OPERATIONS.CLOSE_APPOINTMENT_MODAL,
      refreshList
    );
  }

  async handleOperation(action: string) {
    switch (action) {
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.cancelAppointment();
        break;
      case LIST_DATA_EVENTS.COMPLETE_APPOINTMENT:
        this.completeAppointment();
        break;
    }
  }

  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  onModalCancelAppointment() {
    const modalUserTemplate: SearchContextModal = {
      componentName: COMPONENT_NAME_MODAL.APPOINTMENT,
      callbackHandleOperation: this.handleOperation
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  async getAppointmentDetail(appointmentId: string) {
    try {
      const responseData = await this.medicalAppointmentService.getDetail(
        appointmentId
      );

      if (responseData.code === Http.Found && responseData.data) {
        this.appointmentDate = new Date(
          responseData.data.start
        ).toLocaleDateString("es-CO", OPTIONS_LOCALE_DATE);
        this.suggestions = responseData.data.suggestions;
        this.appointmentPlace = (responseData.data
          .availability as AvailabilityModel).campus as string;
        this.appointmentCampus = (responseData.data
          .availability as AvailabilityModel).space as string;
        this.eventKey = responseData.data.eventKey as string;
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_APPOINTMENT_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  showEvent(index: number) {
    if (index == this.eventSelected) {
      this.showObservationField = false;
      this.eventSelected = -1;
    } else {
      this.eventSelected = index;
      this.showObservationField = true;
      this.calendarValue = this.eventCalendarList[index].start as number;
    }
  }

  async sameServiceScheduledVerification(): Promise<
    { validation: boolean; message: string } | undefined
  > {
    const start = this.eventCalendarList[this.eventSelected].start as number;
    const end = this.eventCalendarList[this.eventSelected].end as number;

    try {
      const validation = await this.medicalAppointmentService.verifyMedicalAppointmentsHoursScheduled(
        this.patientIdProp as string,
        start,
        end,
        this.serviceTemplateIdProp as string,
        true
      );
      if (
        validation.code === Http.Found ||
        validation.code === Http.NoContent
      ) {
        const {
          isBooked,
          coincidences
        } = validation.data as VerifiedAppointmentsResponse;

        if (!isBooked) {
          return {
            validation: false,
            message: ""
          };
        } else {
          return {
            validation: true,
            message: `${SAME_TIME_RANGE_SERVICE_MESSAGE.FIRST_PART} ${coincidences.length} ${SAME_TIME_RANGE_SERVICE_MESSAGE.SECOND_PART}`
          };
        }
      }
      return;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async differentServiceScheduledVerification() {
    const start = this.eventCalendarList[this.eventSelected].start as number;
    const end = this.eventCalendarList[this.eventSelected].end as number;

    try {
      const validation = await this.medicalAppointmentService.verifyMedicalAppointmentsHoursScheduled(
        this.patientIdProp as string,
        start,
        end,
        this.serviceTemplateIdProp as string,
        false
      );
      if (
        validation.code === Http.Found ||
        validation.code === Http.NoContent
      ) {
        const {
          isBooked,
          coincidences
        } = validation.data as VerifiedAppointmentsResponse;

        if (!isBooked) {
          await this.confirmAppointment();
          return false;
        } else {
          const listOfNames: string[] = [];
          const servicesNames = coincidences.map(each => {
            if (!listOfNames.includes(each.service)) {
              listOfNames.push(each.service);
              return each.service;
            }
          });
          this.modalText =
            coincidences.length > 1
              ? `${DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE.FIRST_PART_PLURAL}${servicesNames}${DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE.SECOND_PART_PLURAL}`
              : `${DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE.FIRST_PART_SINGULAR}${servicesNames}${DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE.SECOND_PART_SINGULAR}`;
          this.dialog = true;
          return false;
        }
      }
      return true;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async validationsBeforeBookingAppointment() {
    this.enabledConfirmAppontmentButton = true;
    const scheduledServiceValidation = await this.sameServiceScheduledVerification();
    if (scheduledServiceValidation?.validation) {
      Snackbar.popWarning(scheduledServiceValidation.message);
      this.enabledConfirmAppontmentButton = false;
      return;
    }

    const validateDifferentServices = await this.differentServiceScheduledVerification();

    if (validateDifferentServices) {
      await this.confirmAppointment();
      return;
    }
    this.enabledConfirmAppontmentButton = false;
  }

  async handleModalAccept() {
    this.dialog = false;
    await this.confirmAppointment();
  }

  handleModalCancel() {
    this.dialog = false;
  }

  async confirmAppointment() {
    if (this.assingService) {
      try {
        const response = await this.servicesService.assignService(
          this.serviceToAssing
        );
        if (response.code != Http.Ok) {
          Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.ASSIGN_FAILED);
          this.closeModal(true);
          return;
        }
        this.serviceIdProp = response.data!;
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.POST}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
        this.closeModal(true);
        return;
      }
    }
    const medicalAppointment: MedicalAppointment = {
      suggestions: this.observation,
      availability: this.eventCalendarList[this.eventSelected].campus as string,
      end: this.eventCalendarList[this.eventSelected].end as number,
      name: this.eventCalendarList[this.eventSelected].name as string,
      start: this.eventCalendarList[this.eventSelected].start as number,
      service: this.serviceIdProp as string,
      patient: this.patientIdProp as string
    };

    const events: EventDataModel[] = [];
    this.eventList.forEach(event =>
      events.push({
        eventKey: event._key as string,
        availabilityKey: event.campus as string
      })
    );
    try {
      const responseData = await this.medicalAppointmentService.assignAppointment(
        medicalAppointment,
        this.eventCalendarList[this.eventSelected]._key as string,
        events,
        this.patientIdProp as string
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        const dateAppointment = `${moment(medicalAppointment.start).format(
          "DD/MM/YYYY"
        )}, ${moment(medicalAppointment.start).format("hh:mm:ss A")}`;
        this.modalTitleConfirmation =
          APPOINTMENT_CONSTANTS.MODAL_APPOINTMENT_CONFIRMATION.TITLE;
        this.modalTextConfirmation = `${APPOINTMENT_CONSTANTS.MODAL_APPOINTMENT_CONFIRMATION.TEXT} <strong>${dateAppointment}</strong>`;
        this.dialogConfirmation = true;
      } else if (responseData.code === Http.Conflict) {
        this.fireTimeOutModal();
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getCampus() {
    try {
      const responseData = await this.campusService.getCampusById(
        this.campusKey
      );

      if (responseData.code === Http.Found && responseData.data) {
        this.campusAddress = responseData.data.address;
        this.campusPhone = responseData.data.phone;
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CAMPUS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async cancelAppointment() {
    try {
      const responseData = await this.medicalAppointmentService.cancelAppointment(
        this.medicalAppointmentProp as string,
        this.eventKey
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.closeModal(true);
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async completeAppointment() {
    try {
      const responseData = await this.medicalAppointmentService.completeAppointment(
        this.medicalAppointmentProp as string,
        this.eventKey
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.closeModal(true);
      } else {
        Snackbar.popWarning(responseData.message);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  fireTimeOutModal() {
    this.showTimeOutModal = true;
  }

  async handleTimeOutModal() {
    this.showTimeOutModal = false;
    this.unlockEventsFromEventList();

    if (this.serviceTemplateIdProp) {
      const responseData = await this.availabilityService.getCampusAvailables(
        this.serviceTemplateIdProp
      );

      if (responseData.code != Http.Found) {
        Snackbar.popWarning(responseData.message);
        this.closeModal();
      } else {
        this.getEventsCampus();
      }
    }
  }

  async unlockEventsFromEventList() {
    const events: EventDataModel[] = [];
    this.eventList.forEach(event =>
      events.push({
        eventKey: event._key as string,
        availabilityKey: event.campus as string
      })
    );
    await this.availabilityService.unlockEvents(
      events,
      this.patientIdProp as string
    );
  }

  assignServiceTemplate(data: any) {
    this.assingService = true;
    this.serviceToAssing = data.serviceToAssing;
    this.step = 2;
    this.serviceTemplateIdProp = data.serviceTemplateId;
    this.restoreModal();
  }

  checkCompleteState() {
    if (this.data && this.serviceIdProp) {
      const service = this.data.find(
        serv => serv.id == this.serviceIdProp && serv.state != COMPLETE_SERVICE
      );
      return service ? true : false;
    }
    return false;
  }

  async handleModalAcceptConfirmation() {
    this.dialogConfirmation = false;
    await this.closeModal(true);
  }
}
